import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapGetters } from 'vuex';
import { marked } from 'marked';
import { leaderChat, listAiMetrics } from '@/api/aiAssistant';
import { hasAiPermission, hasAnyAiDataPermission } from '@/utils/aiPermissions';
import { getConversations, getConversation, saveConversation, deleteConversation, createConversation, getSettings, saveSettings } from '@/utils/chatStorage';

// 配置 marked
marked.setOptions({
  breaks: true,
  // 支持换行
  gfm: true // GitHub 风格 Markdown
});
export default {
  name: 'AiChat',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      drawerVisible: false,
      inputMessage: '',
      loading: false,
      conversations: [],
      currentConversationId: null,
      currentMessages: [],
      showConversations: false,
      showQuestionPopover: false,
      abortController: null,
      streamingThinking: '',
      // 流式 thinking 内容
      streamingContent: '',
      // 流式回复内容
      suggestionLoading: false,
      suggestionLoadFailed: false,
      questionGroups: [],
      activeQuestionGroup: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['name', 'avatar'])), {}, {
    // 确保有用户ID（从 store.state.user 中获取）
    effectiveUserId: function effectiveUserId() {
      var _this$$store$state$us, _this$$store$state$us2;
      var userId = ((_this$$store$state$us = this.$store.state.user) === null || _this$$store$state$us === void 0 ? void 0 : _this$$store$state$us.id) || ((_this$$store$state$us2 = this.$store.state.user) === null || _this$$store$state$us2 === void 0 ? void 0 : _this$$store$state$us2.userId) || 'default';
      return "".concat(userId, "_leader_data");
    },
    // 用户头像
    userAvatar: function userAvatar() {
      var _this$$store$state$us3;
      return this.avatar || ((_this$$store$state$us3 = this.$store.state.user) === null || _this$$store$state$us3 === void 0 ? void 0 : _this$$store$state$us3.avatar) || '/images/default-avatar.svg';
    },
    visibleQuestionGroups: function visibleQuestionGroups() {
      var groups = this.questionGroups.length > 0 ? this.questionGroups : this.suggestionLoadFailed ? this.defaultQuestionGroups() : [];
      return this.filterQuestionGroupsByPermission(groups);
    },
    activeQuestionGroupData: function activeQuestionGroupData() {
      var _this = this;
      return this.visibleQuestionGroups.find(function (group) {
        return group.name === _this.activeQuestionGroup;
      }) || this.visibleQuestionGroups[0];
    }
  }),
  watch: {
    visible: function visible(val) {
      this.drawerVisible = val;
      if (val) {
        this.init();
      }
    },
    drawerVisible: function drawerVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    // 初始化
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.loadConversations();
              _this2.loadSettings();
              _this2.loadSuggestedQuestions();

              // 如果没有当前会话，创建一个新的
              if (!_this2.currentConversationId && _this2.conversations.length === 0) {
                _this2.createNewConversation();
              } else if (_this2.conversations.length > 0 && !_this2.currentConversationId) {
                // 加载最近的会话
                _this2.switchConversation(_this2.conversations[0].id);
              }
              _this2.scrollToBottom();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 加载会话列表
    loadConversations: function loadConversations() {
      this.conversations = getConversations(this.effectiveUserId);
    },
    // 加载用户设置
    loadSettings: function loadSettings() {
      var settings = getSettings(this.effectiveUserId);
      if (settings.lastConversationId) {
        this.currentConversationId = settings.lastConversationId;
        var conv = getConversation(this.effectiveUserId, settings.lastConversationId);
        if (conv) {
          this.currentMessages = conv.messages || [];
        }
      }
    },
    // 保存用户设置
    saveUserSettings: function saveUserSettings() {
      saveSettings(this.effectiveUserId, {
        lastConversationId: this.currentConversationId
      });
    },
    loadSuggestedQuestions: function loadSuggestedQuestions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, metrics, groups, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!_this3.suggestionLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this3.suggestionLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return listAiMetrics();
            case 3:
              response = _context2.v;
              metrics = (response === null || response === void 0 ? void 0 : response.data) || [];
              groups = _this3.buildQuestionGroups(metrics);
              _this3.questionGroups = groups;
              _this3.suggestionLoadFailed = false;
              _this3.ensureActiveQuestionGroup();
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.warn('加载 AI 常见问题失败:', _t);
              _this3.questionGroups = _this3.defaultQuestionGroups();
              _this3.suggestionLoadFailed = true;
              _this3.ensureActiveQuestionGroup();
            case 5:
              _context2.p = 5;
              _this3.suggestionLoading = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 4, 5, 6]]);
      }))();
    },
    buildQuestionGroups: function buildQuestionGroups(metrics) {
      var _this4 = this;
      var groupMap = {};
      (metrics || []).forEach(function (metric) {
        var questions = metric.sampleQuestions || metric.SampleQuestions || metric.sample_questions || [];
        if (!questions.length) return;
        var groupName = _this4.getMetricGroupName(metric);
        if (!groupMap[groupName]) {
          groupMap[groupName] = [];
        }
        questions.forEach(function (question) {
          if (question && !groupMap[groupName].includes(question)) {
            groupMap[groupName].push(question);
          }
        });
      });
      var groupOrder = ['学生管理', '考勤统计', '采购库存', '财务数据', '运营数据'];
      return Object.keys(groupMap).sort(function (a, b) {
        var aIndex = groupOrder.indexOf(a);
        var bIndex = groupOrder.indexOf(b);
        return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
      }).map(function (name) {
        return {
          name: name,
          questions: groupMap[name]
        };
      });
    },
    getMetricGroupName: function getMetricGroupName(metric) {
      var scenario = metric.scenario || metric.Scenario || '';
      var category = metric.category || metric.Category || '';
      if (scenario.includes('attendance') || category === 'attendance') return '考勤统计';
      if (scenario.includes('student') || category === 'student') return '学生管理';
      if (category === 'erp' || category === 'stock') return '采购库存';
      if (category === 'finance') return '财务数据';
      return '运营数据';
    },
    filterQuestionGroupsByPermission: function filterQuestionGroupsByPermission(groups) {
      if (hasAiPermission('leaderData')) return groups;
      return (groups || []).filter(function (group) {
        if (group.name === '采购库存' || group.name === '财务数据') {
          return hasAiPermission('erpData');
        }
        if (group.name === '学生管理' || group.name === '考勤统计') {
          return hasAiPermission('studentData');
        }
        return hasAnyAiDataPermission();
      });
    },
    defaultQuestionGroups: function defaultQuestionGroups() {
      return [{
        name: '学生管理',
        questions: ['还有多少学生请假没审批', '还有多少学生未分班', '今天还有多少学生没打卡']
      }, {
        name: '考勤统计',
        questions: ['本月学生出席率是多少', '上个月学生出勤率是多少']
      }];
    },
    ensureActiveQuestionGroup: function ensureActiveQuestionGroup() {
      var _this5 = this;
      var groups = this.visibleQuestionGroups;
      if (!groups.length) {
        this.activeQuestionGroup = '';
        return;
      }
      if (!groups.some(function (group) {
        return group.name === _this5.activeQuestionGroup;
      })) {
        this.activeQuestionGroup = groups[0].name;
      }
    },
    getShortGroupName: function getShortGroupName(groupName) {
      var names = {
        '学生管理': '学生',
        '考勤统计': '考勤',
        '采购库存': 'ERP',
        '财务数据': '财务',
        '运营数据': '运营'
      };
      return names[groupName] || groupName;
    },
    // 创建新会话
    createNewConversation: function createNewConversation() {
      var conv = createConversation('新对话');
      this.conversations.unshift(conv);
      this.currentConversationId = conv.id;
      this.currentMessages = [];
      saveConversation(this.effectiveUserId, conv);
      this.saveUserSettings();
      this.showConversations = false;
    },
    // 切换会话
    switchConversation: function switchConversation(id) {
      var conv = getConversation(this.effectiveUserId, id);
      if (conv) {
        this.currentConversationId = id;
        this.currentMessages = conv.messages || [];
        this.saveUserSettings();
        this.scrollToBottom();
      }
      this.showConversations = false;
    },
    // 删除会话
    deleteConversationHandler: function deleteConversationHandler(id) {
      var _this6 = this;
      this.$confirm('确定删除这个会话吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteConversation(_this6.effectiveUserId, id);
        _this6.loadConversations();
        // 如果删除的是当前会话，切换到其他会话或创建新会话
        if (id === _this6.currentConversationId) {
          if (_this6.conversations.length > 0) {
            _this6.switchConversation(_this6.conversations[0].id);
          } else {
            _this6.createNewConversation();
          }
        }
      }).catch(function () {});
    },
    // 发送消息
    sendMessage: function sendMessage() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var content, conv, assistantMessage, _response$data, _response$data2, response, _conv, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              content = _this7.inputMessage.trim();
              if (!(!content || _this7.loading)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (_this7.canAskDataQuestion(content)) {
                _context3.n = 2;
                break;
              }
              _this7.currentMessages.push({
                role: 'user',
                content: content
              });
              _this7.currentMessages.push({
                role: 'assistant',
                content: '你当前没有权限使用 AI 数据查询能力，请联系管理员开通对应的 AI 助手权限。'
              });
              _this7.inputMessage = '';
              _this7.scrollToBottom();
              return _context3.a(2);
            case 2:
              // 添加用户消息
              _this7.currentMessages.push({
                role: 'user',
                content: content
              });
              _this7.inputMessage = '';
              _this7.scrollToBottom();

              // 更新会话标题（使用第一条消息）
              if (_this7.currentMessages.length === 1) {
                conv = getConversation(_this7.effectiveUserId, _this7.currentConversationId);
                if (conv) {
                  conv.title = content.substring(0, 20) + (content.length > 20 ? '...' : '');
                  conv.messages = _this7.currentMessages;
                  saveConversation(_this7.effectiveUserId, conv);
                  _this7.loadConversations();
                }
              }

              // 发起对话请求
              _this7.loading = true;
              _this7.abortController = new AbortController();
              _this7.streamingThinking = '';
              _this7.streamingContent = '';

              // 准备助手消息对象
              assistantMessage = {
                role: 'assistant',
                content: '',
                thinking: '',
                thinkingExpanded: false
              };
              _context3.p = 3;
              _context3.n = 4;
              return leaderChat({
                message: content,
                sessionId: _this7.currentConversationId,
                source: 'web',
                lang: 'zh-CN'
              }, {
                signal: _this7.abortController.signal
              });
            case 4:
              response = _context3.v;
              assistantMessage.content = (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.reply) || (response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.Reply) || '暂无回复。';
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              if (_t2.name !== 'AbortError') {
                console.error('对话失败:', _t2);
                assistantMessage.content = _this7.getChatErrorMessage(_t2);
              }
            case 6:
              _context3.p = 6;
              // 添加完整的助手消息
              _this7.currentMessages.push(assistantMessage);
              _this7.loading = false;
              _this7.abortController = null;
              _this7.streamingThinking = '';
              _this7.streamingContent = '';
              // 保存会话
              _conv = getConversation(_this7.effectiveUserId, _this7.currentConversationId);
              if (_conv) {
                _conv.messages = _this7.currentMessages;
                saveConversation(_this7.effectiveUserId, _conv);
              }
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, null, [[3, 5, 6, 7]]);
      }))();
    },
    canAskDataQuestion: function canAskDataQuestion(content) {
      if (hasAiPermission('leaderData')) return true;
      var text = content || '';
      var erpKeywords = ['采购', '请购', '入库', '出库', '库存', '供应商', '物料', '供货'];
      var studentKeywords = ['学生', '学员', '请假', '未分班', '打卡', '签到', '缺勤', '出席率', '出勤率', '考勤'];
      var summaryKeywords = ['聚全情况', '领导周报', '经营总览', '数据总览', '整体情况', '汇总'];
      if (summaryKeywords.some(function (keyword) {
        return text.includes(keyword);
      })) {
        return hasAnyAiDataPermission();
      }
      if (erpKeywords.some(function (keyword) {
        return text.includes(keyword);
      })) {
        return hasAiPermission('erpData');
      }
      if (studentKeywords.some(function (keyword) {
        return text.includes(keyword);
      })) {
        return hasAiPermission('studentData');
      }
      return true;
    },
    // 切换 thinking 展开/折叠
    toggleThinking: function toggleThinking(index) {
      var msg = this.currentMessages[index];
      if (msg) {
        this.$set(msg, 'thinkingExpanded', !msg.thinkingExpanded);
      }
    },
    // 停止生成
    stopGeneration: function stopGeneration() {
      if (this.abortController) {
        this.abortController.abort();
      }
    },
    getChatErrorMessage: function getChatErrorMessage(error) {
      var _error$response;
      var data = error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
      var detail = data === null || data === void 0 ? void 0 : data.detail;
      var message = typeof detail === 'string' && detail || (detail === null || detail === void 0 ? void 0 : detail.message) || (detail === null || detail === void 0 ? void 0 : detail.msg) || (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.msg) || (data === null || data === void 0 ? void 0 : data.error_description) || (data === null || data === void 0 ? void 0 : data.error) || (error === null || error === void 0 ? void 0 : error.message) || '请求失败，请稍后再试。';
      if (this.isDataUnavailableError(message)) {
        return '暂未找到可用的相关数据，请换个问法或联系管理员确认数据配置。';
      }
      return message.startsWith('抱歉') ? message : "\u62B1\u6B49\uFF0C\u53D1\u751F\u4E86\u9519\u8BEF\uFF1A".concat(message);
    },
    isDataUnavailableError: function isDataUnavailableError(message) {
      return ['暂未找到可用的相关数据', '未知的 metric', '指标未启用或不存在', '未找到指标处理器'].some(function (keyword) {
        return message.includes(keyword);
      });
    },
    useSampleQuestion: function useSampleQuestion(question) {
      this.showQuestionPopover = false;
      this.inputMessage = question;
      this.sendMessage();
    },
    // 键盘事件处理
    handleKeydown: function handleKeydown(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.sendMessage();
      }
    },
    // 滚动到底部
    scrollToBottom: function scrollToBottom() {
      var _this8 = this;
      this.$nextTick(function () {
        var container = _this8.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    // 格式化消息（支持 Markdown）
    formatMessage: function formatMessage(content) {
      if (!content) return '';
      // 使用 marked 解析 Markdown
      return marked(content);
    },
    // 关闭抽屉
    handleClose: function handleClose() {
      this.drawerVisible = false;
    }
  }
};